// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1sUv-","colCheckbox":"styles_colCheckbox__1WikD"};